import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'antd';
import { Button, BUTTON_TYPES, DatePicker, Input, Popup, RichArea, Typography } from '_atoms';
import { RULES } from '_organisms/Offer/constants';
import './style.scss';

interface PopupCreateOfferUserData {
  full_name_latin?: string;
  full_name_local?: string;
  speciality?: string | null;
  link?: string;
}

interface PopupCreateOfferFormValues {
  probation_period?: string;
  date?: unknown;
  comment?: string;
}

interface PopupCreateOfferProps {
  open: boolean;
  userData: PopupCreateOfferUserData;
  onClose: () => void;
  onSave: (values: PopupCreateOfferFormValues) => void;
}

const initialValues: Partial<PopupCreateOfferFormValues> = {};

export const PopupCreateOffer: React.FC<PopupCreateOfferProps> = ({ open, onClose, onSave, ...props }) => {
  const { t } = useTranslation();
  return (
    <Popup
      className="popup-create-offer mobile-full-size"
      open={open}
      title={t('translation:popup_create_offer.title_add_offer')}
      onClose={onClose}
    >
      <div className="user-info">
        <Typography.Text className="user-info__title">{props.userData.full_name_latin}</Typography.Text>
        <Typography.Caption className="user-info__subtitle">{props.userData.full_name_local}</Typography.Caption>
        <Typography.Caption className="user-info__subtitle">{props.userData.speciality}</Typography.Caption>
        {props.userData.link && (
          <a target="_blank" href={props.userData.link} rel="noreferrer">
            <Button type={BUTTON_TYPES.TEXT}>{t('translation:popup_create_offer.button_view')}</Button>
          </a>
        )}
      </div>
      <Form onFinish={onSave} initialValues={initialValues} validateTrigger="onSubmit">
        <Row gutter={12}>
          <Col lg={12} md={12} sm={12}>
            <Input
              label={t('translation:popup_create_offer.label_probation_period')}
              placeholder={t('translation:popup_create_offer.ph_probation_period')}
              itemProps={{ name: 'probation_period', rules: RULES.PERIOD }}
            />
          </Col>
          <Col lg={12} md={12} sm={12}>
            <Typography.Text className="months">{t('translation:popup_create_offer.text_months')}</Typography.Text>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col lg={12} md={12} sm={12}>
            <DatePicker
              label={t('translation:popup_create_offer.label_expected_answer_date')}
              itemProps={{ name: 'date', rules: RULES.DATE }}
            />
          </Col>
        </Row>
        <Form.Item name="comment">
          <RichArea
            label={t('translation:popup_create_offer.label_comment')}
            placeholder={t('translation:popup_create_offer.ph_comment')}
            initialValue={initialValues.comment}
            maxLength={6000}
          />
        </Form.Item>
        <div className="job-offer__content-footer">
          <Button onClick={onClose}>{t('translation:popup_create_offer.button_cancel')}</Button>
          <Button htmlType="submit" type={BUTTON_TYPES.PRIMARY}>
            {t('translation:popup_create_offer.button_add')}
          </Button>
        </div>
      </Form>
    </Popup>
  );
};
